import React, { Component, } from 'react';
import  {images, colors} from './../../cc-imports';
import PropTypes from 'prop-types';
import './../../styles/css/components/CCCoinPile/cc-coin-pile.css'

class CCCoinPile extends Component {

    static propTypes = {
        onPress:PropTypes.func,
        disabled : PropTypes.bool,
        coins : PropTypes.number,
        theme : PropTypes.string,
        icon : PropTypes.string,
        uiDisabled : PropTypes.bool
    };

    static defaultProps = {
        onClick:()=>{},
        disabled : false,
        coins : 0,
        theme : 'default',

        icon: undefined,
        className : '',
        textClass : '',
        iconClass : '',
        uiDisabled : false
    };


    constructor(props) {
        super(props);
        this.state = {};
        this._getIcon=this._getIcon.bind(this);
    }


    _getIcon(theme, icon, uiDisabled){
        var finalIcon = icon;
        if(!icon) finalIcon = theme === 'dark' ? images.icons.coinsPileDark:images.icons.coinsPile;
        if(uiDisabled) finalIcon = images.icons.disabled.coinsPile;
        return finalIcon;

    }

    _getFontColor(theme) {
        var color = theme=='dark' ? colors.theme2.font_color1:colors.theme2.font_color3;
        color = this.props.uiDisabled == true ? colors.theme2.font_color5 : color;
        return color;
    }

    render() {
        const {coins, theme, icon, className, textClass, iconClass, disabled, uiDisabled, } = this.props;


        return (
            <div className={className} onClick={this.props.onClick} style={{ ...this.props.style}} disabled={disabled}>
                <div className={'flex-container'} style={{alignItems: 'center'}}>
                    <img className={'flex-container ' + iconClass} src={this._getIcon(theme, icon, uiDisabled)}
                         style={{alignItems: 'center'}}/>

                    <h2 className={textClass} style={{ alignItems:'center', marginBottom:3, color : this._getFontColor(theme)}}>{coins}</h2>
                </div>
            </div>
        )
    }
}

export default CCCoinPile


// WEBPACK FOOTER //
// ./src/app/components/CCCoinPile/CCCoinPile.js